var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.802 23.1029H7.19899C2.95799 23.1029 1.89899 22.0429 1.89899 17.8029V15.6809C1.89899 11.4399 2.95899 10.3809 7.19899 10.3809H17.799C22.04 10.3809 23.099 11.4409 23.099 15.6809V17.8019C23.104 22.0429 22.044 23.1029 17.802 23.1029Z",
    stroke: "#415568",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.138 10.38V8.25897C6.138 4.74897 7.198 1.89697 12.5 1.89697C17.271 1.89697 18.862 4.01797 18.862 7.19697",
    stroke: "#415568",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.3928C13.0243 19.3928 13.5369 19.2373 13.9728 18.946C14.4088 18.6548 14.7486 18.2407 14.9492 17.7563C15.1499 17.2719 15.2023 16.7389 15.1001 16.2246C14.9978 15.7104 14.7453 15.238 14.3745 14.8673C14.0038 14.4965 13.5314 14.244 13.0172 14.1418C12.5029 14.0395 11.9699 14.092 11.4855 14.2926C11.0011 14.4933 10.5871 14.833 10.2958 15.269C10.0045 15.705 9.849 16.2175 9.849 16.7418C9.849 17.4449 10.1283 18.1192 10.6255 18.6164C11.1226 19.1135 11.7969 19.3928 12.5 19.3928Z",
    stroke: "#415568",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.9731dc38bdd2c33487307d91c35af1fb.svg";
export { ForwardRef as ReactComponent };